/**
 * Bahasa Melayu — DRAFT TRANSLATION, PENDING SIGN-OFF.
 *
 * Scope: the corporate pages (Home, The Group, Our Businesses, Governance,
 * Sustainability, Newsroom, Contact) plus the site chrome. Investor Relations
 * filings, announcement titles and bodies are never translated — they are the
 * official record as released to SGXNet, and neither are the CEO's own
 * quotations, which stay in the language he published them in.
 *
 * Legal entity names, brand names, product designations, addresses and figures
 * are left exactly as published. Regulated English terms are kept in brackets on
 * first use where the English is the term of art.
 *
 * Anything omitted here falls back to the English wording.
 */
import { HERITAGE_YEARS } from '../data/heritage';

const ms = {
  PRIMARY_NAV: [
    { label: 'Laman Utama' },
    { label: 'Perhubungan Pelabur' },
    { label: 'Kumpulan' },
    { label: 'Perniagaan Kami' },
    { label: 'Tadbir Urus' },
    { label: 'Kemampanan' },
    { label: 'Ruang Berita' },
    { label: 'Hubungi Kami' },
  ],

  FOOTER_COLUMNS: [
    {
      heading: 'Syarikat',
      links: [
        { label: 'Laman Utama' },
        { label: 'Kumpulan' },
        { label: 'Perniagaan Kami' },
        { label: 'Tadbir Urus' },
      ],
    },
    { heading: 'Perniagaan Kami' },
    {
      heading: 'Pelabur',
      links: [
        { label: 'Pengumuman' },
        { label: 'Keputusan kewangan' },
        { label: 'Laporan tahunan' },
        { label: 'Maklumat saham' },
        { label: 'Makluman e-mel' },
        { label: 'Hubungan pelabur' },
      ],
    },
    {
      heading: 'Berhubung',
      links: [
        { label: 'Hubungi Kami' },
        { label: 'Ruang Berita' },
      ],
    },
  ],

  LEGAL_LINKS: [
    { label: 'Terma Penggunaan' },
    { label: 'Polisi Privasi' },
    { label: 'Penafian' },
    { label: 'Polisi Kuki' },
    { label: 'Notis Penting' },
  ],

  UI: {
    common: {
      home: 'Laman Utama',
      ir: 'Perhubungan Pelabur →',
      search: 'Cari',
      searchAria: 'Cari dalam laman ini',
      language: 'Bahasa',
      languageNote:
        'Halaman korporat tersedia dalam tiga bahasa. Dokumen Perhubungan Pelabur kekal dalam bahasa Inggeris, seperti yang dikeluarkan melalui SGXNet.',
      draftLabel: 'Terjemahan draf',
      draftNotice:
        'Halaman ini ialah terjemahan draf yang masih menunggu pengesahan Kumpulan. Sekiranya terdapat perbezaan, versi bahasa Inggeris yang diguna pakai.',
      englishOnlyLabel: 'Bahasa Inggeris sahaja',
      englishOnlyNotice:
        'Halaman Perhubungan Pelabur dan halaman perundangan diterbitkan dalam bahasa Inggeris sahaja. Pengumuman ialah rekod rasmi seperti yang dikeluarkan melalui SGXNet.',
      readInEnglish: 'Baca dalam bahasa Inggeris',
      autoLabel: 'Bahasa dipadankan',
      autoNotice:
        'Kami memaparkan halaman ini mengikut tetapan bahasa pelayar anda. Ia merupakan terjemahan draf yang masih menunggu pengesahan Kumpulan — sekiranya terdapat perbezaan, versi bahasa Inggeris yang diguna pakai.',
      skipToContent: 'Langkau ke kandungan',
      scrollToTop: 'Kembali ke atas',
      viewPhoto: 'Lihat gambar',
      downloadPhoto: 'Muat turun gambar',
      previousPhoto: 'Gambar sebelumnya',
      nextPhoto: 'Gambar seterusnya',
      close: 'Tutup',
      chapters: 'Bab',
      playFrom: 'Main dari',
      videoSilent: 'Rakaman senyap · tiada narasi',
      videoUnsupported: 'Pelayar anda tidak dapat memainkan video ini.',
      captionsMalay: 'Sari kata BM',
      downloadVideo: 'Muat turun video (MP4)',
      menu: 'Menu',
      menuNote: 'Navigasi laman, carian dan pilihan bahasa.',
      cookieSettings: 'Tetapan kuki',
      awaitingApproval: 'Menunggu kelulusan',
      poweredBy: 'Dikuasakan oleh',
      personnelProfile: 'Profil Personel',
      printDocument: 'Cetak atau simpan sebagai PDF',
      printHint: 'Salinan bercetak membawa versi, tarikh berkuat kuasa dan URL sumber.',
      skipIntro: 'Langkau',
      listedOn: 'Tersenarai di',
      rightsReserved: 'Hak cipta terpelihara.',
    },
    cookies: {
      aria: 'Keutamaan kuki',
      copy:
        'Kami menggunakan kuki untuk mengendalikan laman ini dan menambah baik pengalaman anda. Anda boleh menerima semua kuki atau menetapkan keutamaan anda.',
      policy: 'Polisi Kuki',
      necessaryLabel: 'Sangat diperlukan',
      necessaryNote: 'diperlukan untuk mengendalikan laman ini. Sentiasa aktif.',
      necessaryAria: 'Kuki yang sangat diperlukan',
      analyticsLabel: 'Analitik',
      analyticsNote: 'membantu kami memahami cara laman ini digunakan.',
      marketingLabel: 'Pemasaran',
      marketingNote: 'mengukur prestasi kempen kami.',
      manage: 'Tetapkan keutamaan',
      save: 'Simpan keutamaan',
      reject: 'Tolak yang tidak penting',
      accept: 'Terima semua',
    },
    trading: {
      aria: 'Status dagangan',
      status: 'Status dagangan',
      resumption: 'Penyambungan semula dagangan',
      link: 'Maklumat saham →',
      dismiss: 'Tutup notis status dagangan',
    },
    home: {
      scroll: 'Tatal',
      glanceAria: 'Kumpulan secara ringkas',
    },
    group: {
      eyebrow: 'Kumpulan',
      h1: 'Kumpulan',
    },
    structure: {
      heading: 'Entiti dan pemilikan',
      listedHolding: 'Syarikat induk tersenarai',
      tapHint: 'Pilih entiti untuk melihat profilnya',
      openProfile: 'Buka profil untuk',
      profileEyebrow: 'Profil entiti',
      activity: 'Aktiviti',
      ownership: 'Pemilikan',
      heldBy: 'Dipegang oleh',
      directStake: 'Kepentingan langsung',
      position: 'Kedudukan dalam Kumpulan',
      subsidiaries: 'Subsidiari langsung',
      noSubsidiaries: 'Tiada subsidiari dalam struktur Kumpulan.',
      noteLabel: 'Nota',
      close: 'Tutup',
      segmentsLabel: 'Segmen:',
      crossHolding: '{stake} dipegang oleh {holder}',
      chartEyebrow: 'Struktur Kumpulan',
      chartTitle: 'dan anak-anak syarikatnya',
      scrollHint: 'Leret carta ke sisi untuk melihat setiap entiti',
      zoomHint: 'Cubit, ketik dua kali atau guna kawalan untuk membesarkan carta',
      zoomIn: 'Besarkan',
      zoomOut: 'Kecilkan',
      zoomFit: 'Muat',
      type: {
        listed: 'Syarikat tersenarai',
        holding: 'Syarikat induk',
        operating: 'Syarikat operasi',
        dormant: 'Tidak aktif / pegangan hartanah',
      },
      segments: {
        marine: 'Marin',
        instrumentation: 'Instrumentasi',
        healthcare: 'Penjagaan kesihatan',
      },
    },
    fishingApp: {
      layersAria: 'Lapisan data',
      illustrative: 'Visualisasi ilustrasi · tiada suapan data langsung',
      play: 'Mainkan ramalan tujuh hari',
      pause: 'Jeda tayangan tujuh hari',
      timeline: 'Garis masa tujuh hari',
      days: ['Rab', 'Kha', 'Jum', 'Sab', 'Ahd', 'Isn', 'Sel'],
      species: ['Kembung', 'Sotong', 'Tuna'],
      layers: [
        { label: 'Suhu', detail: 'Gradien suhu permukaan laut.' },
        { label: 'Gelombang', detail: 'Anjakan alun yang diperkuat.' },
        { label: 'Klorofil', caption: 'Kepulan pertumbuhan pesisir', detail: 'Tempat ikan mencari makan.' },
        { label: 'Angin', caption: '5 kn · tiupan 6 kn', detail: 'Garis aliran medan angin beranimasi.' },
        { label: 'Ikan', caption: 'Kebarangkalian spesies', detail: 'Kembung · Sotong · Tuna' },
        { label: 'Navigasi', caption: 'Kontur kedalaman · laluan · AIS', detail: 'Mod peta nautika.' },
      ],
    },
    businesses: {
      eyebrow: 'Perniagaan Kami',
      h1: 'Perniagaan Kami',
      brandPartners: 'Rakan jenama',
      typeOnlyNote:
        'Tanda jenama adalah hak milik pemilik masing-masing dan dipaparkan seperti yang dibekalkan.',
      boats: 'Kayak',
      boatsRailAria: 'Kayak yang diedarkan oleh Supratechnic',
      step: 'Langkah',
      suprayiClients: 'Pelanggan terpilih SupraYi',
      suprayiClientsNote:
        'Diterbitkan di suprayi.com sebagai pelanggan SupraYi. Kebenaran akan disahkan sebelum pelancaran; ia tidak dipersembahkan sebagai rujukan seluruh Kumpulan.',
      iqairRailAria: 'Produk IQAir yang ditawarkan oleh SupraYi',
      siiPartnersNote:
        'Tiada fail logo jenama bagi empat rakan ini, jadi ia dipersembahkan sebagai dinding tipografi dan bukan direka.',
      instrumentation: 'Produk instrumentasi & keselamatan',
      instrumentationRailAria: 'Produk instrumentasi dan pengesanan gas yang dibekalkan oleh SII',
      certifications: 'Pensijilan',
      siiLeadership: 'Kepimpinan SII',
      fishingAppEyebrow: 'Kepintaran terpakai · Aplikasi Perikanan Pintar',
      fishingAppTitle: 'Kepintaran marin dan perikanan',
      fishingAppCopy:
        'Data satelit, oseanografi dan vesel diterjemahkan menjadi keputusan yang boleh diambil oleh nakhoda sebelum meninggalkan pelabuhan — tiga bahasa, berfungsi luar talian dan sedar armada.',
      comingSoon: 'Akan datang',
      registryCaption: 'Perwakilan ilustrasi bagi daftar kelayakan.',
    },
    governance: {
      eyebrow: 'Tadbir Urus',
      h1: 'Tadbir Urus',
      managementTeam: 'Pasukan Pengurusan',
      composition: 'Komposisi',
      chair: 'Pengerusi',
      member: 'Anggota',
    },
    sustainability: {
      eyebrow: 'Kemampanan',
      h1: 'Kemampanan',
    },
    contact: {
      eyebrow: 'Hubungi Kami',
      name: 'Nama',
      email: 'E-mel',
      phone: 'Telefon',
      type: 'Jenis pertanyaan',
      subject: 'Perkara',
      message: 'Mesej',
      select: 'Sila pilih…',
      types: {
        General: 'Umum',
        Investor: 'Pelabur',
        Media: 'Media',
        Partnership: 'Perkongsian',
      },
      send: 'Hantar mesej',
      privacyBefore: 'Dengan menghantar, anda bersetuju dengan ',
      privacyLink: 'Polisi Privasi',
      privacyAfter: ' kami. Butiran anda digunakan hanya untuk menjawab pertanyaan anda.',
      telephone: 'Telefon',
      emailLabel: 'E-mel',
      websiteLabel: 'Laman web',
      hoursLabel: 'Waktu operasi:',
      irHeading: 'Perhubungan Pelabur',
      irNote:
        'Untuk pertanyaan pemegang saham, penganalisis dan media mengenai Kumpulan dan pendedahannya.',
      irLink: 'Hubungan Perhubungan Pelabur →',
      errors: {
        name: 'Sila masukkan nama anda.',
        email: 'Sila masukkan alamat e-mel yang sah.',
        type: 'Sila pilih jenis pertanyaan.',
        message: 'Sila masukkan mesej anda.',
      },
      toastCheck: 'Sila periksa medan yang ditandakan',
      toastReceived: 'Mesej diterima',
      toastError: 'Berlaku masalah',
    },
  },

  HOME: {
    hero: {
      eyebrow: 'Papan Utama SGX · Singapura · Malaysia · Indonesia',
      h1: 'Warisan pengedaran. Masa depan berasaskan kepintaran.',
      sub:
        'Kumpulan ini merangkumi beberapa negara dalam bidang marin, industri, penjagaan kesihatan dan instrumentasi saintifik — dan kini sedang membina keupayaan AI, automasi serta teknologi pemasaran yang akan menentukan babak seterusnya.',
      primary: { label: 'Perhubungan Pelabur →' },
      secondary: { label: 'Terokai Kumpulan' },
    },
    latest: {
      eyebrow: 'Terkini daripada Kumpulan',
      heading: 'Pengumuman berkanun',
      viewAll: { label: 'Lihat semua pengumuman →' },
      empty:
        'Pengumuman akan muncul di sini sebaik sahaja Kumpulan menyambung pemfailan di SGXNet.',
    },
    stats: [
      { label: 'Tahun pengedaran serantau' },
      { label: 'Negara — Singapura, Malaysia, Indonesia' },
      { label: 'Barisan jenama diwakili' },
      { label: 'Tersenarai di Papan Utama' },
    ],
    ecosystem: {
      eyebrow: 'Ekosistem',
      h2: 'Satu kumpulan. Tiga teras. Satu roda tenaga.',
      intro:
        'Perniagaan kami dibina untuk saling menguatkan — sebuah enjin hasil yang menghasilkan data dunia nyata, satu lapisan kepintaran yang menukar data itu menjadi alat, dan satu pemecut keupayaan yang menggandakan kesemuanya.',
      cards: [
        {
          label: 'Pengedaran & Instrumentasi',
          title: 'Enjin Hasil',
          copy:
            `Supratechnic dan SII — lebih ${HERITAGE_YEARS} tahun pengedaran serantau yang dipercayai dalam bidang marin, industri, penjagaan kesihatan dan instrumentasi saintifik. Tulang belakang penjana tunai Kumpulan.`,
          link: { label: 'Terokai perniagaan →' },
        },
        {
          label: 'AI, Teknologi Pemasaran & Perkhidmatan Kumpulan',
          title: 'Sistem Saraf Pusat',
          copy:
            'SuprAI Pte Ltd membina alat AI, automasi dan teknologi pemasaran Kumpulan — dibuktikan dahulu pada perniagaan kami sendiri, kemudian diproduktkan untuk pelanggan. Daripada pusat kos kepada pusat keuntungan.',
          link: { label: 'Cara SuprAI berfungsi →' },
        },
        {
          label: 'Pemecut Teknologi & RWA',
          title: 'Pemecut Keupayaan',
          copy:
            'Kepentingan strategik sebagai syarikat sekutu dalam sebuah syarikat permulaan teknologi memecut keupayaan teknologi dan produk Kumpulan — dengan tokenisasi aset dunia nyata sebagai pilihan yang telah disahkan pengawal selia untuk masa depan.',
          link: { label: 'Laluan teknologi kami →' },
        },
      ],
    },
    fishingApp: {
      eyebrow: 'Kepintaran terpakai · Aplikasi Perikanan Pintar',
      h2: 'Kepintaran, di tempat kerja sebenar berlaku.',
      intro:
        'Aplikasi Perikanan Pintar dibina untuk perairan yang telah dikhidmati Kumpulan lebih setengah abad. Ia menukar data satelit, oseanografi dan vesel menjadi keputusan yang boleh diambil oleh nakhoda sebelum meninggalkan pelabuhan — suhu permukaan laut, ketinggian gelombang, klorofil, angin, ramalan spesies dan navigasi, dalam tiga bahasa, pada telefon, tanpa perlu talian.',
      tiles: [
        {
          title: 'Tiga bahasa secara asali',
          copy: 'Inggeris · Bahasa Melayu · Bahasa Indonesia — dibina untuk kru yang benar-benar menggunakannya.',
        },
        {
          title: 'Berfungsi luar talian',
          copy: 'Peta luar talian dan mod penjimatan data, kerana liputan berakhir di garis pantai.',
        },
        {
          title: 'Sedar armada',
          copy: 'Kedudukan vesel, laluan dan lapisan keselamatan pada satu peta.',
        },
      ],
      closing:
        'Aplikasi Perikanan Pintar ialah keupayaan Kumpulan, dibangunkan oleh SuprAI Pte Ltd berasaskan pengetahuan operasi Supratechnic dan SII.',
    },
    techBand: {
      eyebrow: 'Di mana teknologi bertemu Kumpulan',
      h2: 'Tiga permukaan, satu tindanan keupayaan.',
      tiles: [
        {
          eyebrow: 'AI terpakai',
          copy: 'Kepintaran marin dan perikanan, berjalan di perairan yang telah dikhidmati Kumpulan.',
          link: { label: 'Lihat paparan lautan →' },
        },
        {
          eyebrow: 'Tindanan SuprAI',
          title: 'Isyarat masuk, struktur keluar',
          copy: 'Data operasi yang berselerak dijernihkan menjadi alat yang menajamkan setiap perniagaan.',
          link: { label: 'Cara SuprAI berfungsi →' },
        },
        {
          eyebrow: 'Tokenisasi RWA',
          title: 'Pilihan yang diukur',
          copy:
            'Tokenisasi aset dunia nyata dipegang sebagai pilihan yang telah disahkan pengawal selia, untuk diterokai secara berperingkat apabila pasaran itu matang.',
          link: { label: 'Laluan teknologi kami →' },
        },
      ],
    },
    cta: {
      h2: 'Dibina atas disiplin. Bersedia untuk masa depan.',
      copy:
        'Ketika kami menyambung semula perdagangan di Papan Utama SGX, komitmen kami ialah ketelusan, tadbir urus yang mantap dan strategi penciptaan nilai yang jelas.',
      button: { label: 'Perhubungan Pelabur →' },
      micro: 'Harga saham dan maklumat kewangan akan dikemas kini sebaik perdagangan disambung.',
    },
  },

  FLYWHEEL: {
    eyebrow: 'Roda Tenaga',
    h2: 'Bagaimana Kumpulan menggandakan nilai.',
    closing: 'Roda itu berputar lagi, lebih pantas setiap kali.',
    groupCopy:
      'Pengedaran menghasilkan hasil dan data. AI serta teknologi pemasaran menukar data itu menjadi alat yang menajamkan setiap perniagaan. Syarikat permulaan teknologi memecut pembinaannya. Modal dan bakat mengalir semula ke pengedaran — dan roda itu berputar lagi, lebih pantas setiap kali.',
    stages: [
      {
        title: 'Pengedaran',
        copy:
          'Pengedaran menghasilkan hasil dan data dunia nyata di tiga negara — marin, industri, penjagaan kesihatan dan instrumentasi saintifik.',
      },
      {
        title: 'AI & Teknologi Pemasaran',
        copy:
          'AI dan teknologi pemasaran menukar data itu menjadi alat yang menajamkan setiap entiti operasi — dibuktikan di dalam, kemudian dijual di luar.',
      },
      {
        title: 'Pemecutan Teknologi',
        copy:
          'Sebuah syarikat permulaan teknologi memecut keupayaan teknologi dan projek Kumpulan, dengan tokenisasi RWA sebagai pilihan selari.',
      },
      {
        title: 'Modal & Bakat',
        copy: 'Modal dan bakat mengalir semula ke pengedaran — dan roda itu berputar lagi, lebih pantas setiap kali.',
      },
    ],
  },

  GROUP: {
    overview: {
      h2: 'Mengenai Kumpulan',
      paragraphs: [
        `Kumpulan ini berpangkalan di Singapura dan tersenarai di Papan Utama SGX, dengan operasi di Singapura, Malaysia dan Indonesia. Selama lebih ${HERITAGE_YEARS} tahun, perniagaan pengedaran kami telah membekalkan instrumentasi marin, industri, penjagaan kesihatan dan saintifik bermutu tinggi kepada pelanggan dalam industri yang berkanun dan menuntut ketepatan.`,
        'Hari ini, Kumpulan sedang berubah. Kami membina keupayaan kecerdasan buatan, automasi dan teknologi pemasaran — membuktikannya terlebih dahulu di seluruh syarikat operasi kami sendiri, kemudian menawarkannya kepada pelanggan di rantau ini dan seterusnya. Cita-cita kami ialah berkembang daripada pengedar serantau yang dihormati menjadi kumpulan dua enjin: satu asas hasil yang mapan, dan satu perniagaan kepintaran yang berkembang di atasnya.',
      ],
      pullQuote: 'Satu kumpulan, dilaksanakan dengan disiplin, bergabung menjadi kepercayaan — dan menjadi nilai.',
    },
    pillars: {
      h2: 'Tiga teras, bergerak sebagai satu',
      intro:
        'Strategi kami berdiri atas tiga teras di bawah satu syarikat induk tersenarai. Setiap satu menguatkan yang berikutnya.',
      paragraphs: [
        `Supratechnic dan SII ialah enjin hasil Kumpulan: lebih ${HERITAGE_YEARS} tahun pengedaran dalam bidang marin, industri, penjagaan kesihatan dan instrumentasi saintifik di tiga negara. Kedua-duanya menjana hasil berulang dan data operasi dunia nyata yang menggerakkan segala yang berada di atasnya.`,
        'SuprAI Pte Ltd ialah sistem saraf pusat Kumpulan. Ia membina produk AI, automasi dan teknologi pemasaran, menggunakannya dahulu pada perniagaan kami sendiri, dan memusatkan perkhidmatan bersama seluruh Kumpulan. Setelah dibuktikan di dalam, tindanan itu menjadi produk yang boleh kami jual.',
        'Melalui kepentingan minoriti strategik dalam sebuah syarikat permulaan teknologi, Kumpulan memecut keupayaan teknologi, pembangunan produk dan pengurusan projek yang diperlukan hari ini — dengan tokenisasi aset dunia nyata sebagai pilihan yang telah disahkan pengawal selia untuk masa depan.',
      ],
    },
    milestones: {
      h2: 'Perjalanan kami',
      intro: 'Daripada perniagaan pengedaran serantau kepada kumpulan tersenarai yang sedang berubah.',
      items: [
        {
          year: '1968',
          text:
            'Supratechnic Pte Ltd diperbadankan di Singapura, meletakkan asas perniagaan pengedaran Kumpulan.',
        },
        {
          year: '1975',
          text: 'SII ditubuhkan, membawa instrumentasi saintifik dan industri kepada Kumpulan.',
        },
        {
          year: '31 Jan 2007',
          text: 'Disenaraikan di Papan Utama Bursa Saham Singapura.',
        },
        { year: '23 Feb 2024', text: 'Perdagangan saham Syarikat digantung.' },
        {
          year: '11 Jun 2024',
          text: 'Pengurus Kehakiman Bersama dan Berasingan dilantik.',
          detail: 'Pengurus kehakiman interim telah dilantik pada 11 Mac 2024.',
        },
        {
          year: '19 Sep 2025',
          text: 'Perjanjian Kemudahan Pinjaman Bersyarat dengan Ascendro Group Limited.',
          detail:
            'Ascendro komited sebanyak S$3.0 juta — S$2.0 juta untuk membiayai pengagihan kepada pemiutang di bawah skim pengaturan dan S$1.0 juta untuk yuran profesional dan perbelanjaan penstrukturan semula.',
        },
        { year: '9 Apr 2026', text: 'Pemiutang meluluskan skim pengaturan.' },
        { year: '21 Mei 2026', text: 'Mahkamah Tinggi mengesahkan skim pengaturan.' },
        { year: '18 Jul 2026', text: 'Syarikat dilepaskan daripada pengurusan kehakiman.' },
        {
          year: '30 Jul 2026',
          text:
            'Lembaga Pengarah disusun semula dengan majoriti pengarah bebas, dan Jawatankuasa AI dan Teknologi ditubuhkan.',
        },
        {
          year: 'Ogos 2026',
          text:
            'Dilantik sebagai pengedar sah enjin sangkut Tohatsu bagi Semenanjung Malaysia, dan SII memeterai usaha sama dengan kumpulan Kimera Health pada 26 Ogos 2026.',
        },
        {
          year: '26 Okt 2026',
          text:
            'Penyata kewangan teraudit FY2026 dikeluarkan dengan pendapat audit tanpa pengubahsuaian.',
        },
        { year: '12 Nov 2026', text: 'Mesyuarat agung tahunan gabungan bagi FY2022 hingga FY2026.' },
        {
          year: 'Akan datang',
          pending: true,
          text: 'Penyambungan semula perdagangan di Papan Utama SGX.',
          detail: 'Tertakluk kepada kelulusan SGX-ST, dan tidak dijamin.',
        },
      ],
    },
    structure: {
      h2: 'Bagaimana kami disusun',
      intro:
        'Kumpulan ialah syarikat induk tersenarai. Di bawahnya terletak entiti operasi dan modal yang membentuk tiga teras tersebut.',
      notesLabel: 'Nota',
      notes: [
        'SuprAI Pte. Ltd. dahulunya dikenali sebagai Supratechnic SII Pte. Ltd.; SuprAI Capital Pte. Ltd. dahulunya dikenali sebagai Supratechnic Capital Pte. Ltd.',
        'Scientific & Industrial Instrumentation Pte. Ltd. dipegang 100% oleh SuprAI Pte. Ltd.',
        'PT Supratechnic Instrumentasi dipegang 90% oleh Supratechnic Pte. Ltd. dan 10% oleh Supratechnic (M) Sdn. Bhd.',
        'Anak syarikat yang tidak aktif, dalam penggulungan atau sedang dipotong daripada daftar, serta cadangan pelaburan, tidak ditunjukkan. Butiran semua anak syarikat dinyatakan dalam penyata kewangan teraudit bagi FY2026.',
      ],
    },
    leadership: {
      h2: 'Kepimpinan',
      intro:
        'Pengurusan kanan dan Setiausaha Syarikat Bersama, seperti yang diterbitkan dalam Laporan Tahunan 2026.',
      source: 'Menurut Laporan Tahunan 2026 Syarikat (28 Oktober 2026).',
      pending:
        'Profil kepimpinan akan diterbitkan setelah mendapat kelulusan Lembaga Pengarah dan Setiausaha Syarikat.',
    },
  },

  STRUCTURE_TREE: {
    role: 'Singapura \u00b7 Pegangan pelaburan',
    detail: 'Tersenarai di Papan Utama SGX-ST',
    children: [
      {
        role: 'Singapura \u00b7 Syarikat induk perantaraan',
        children: [
          {
            role: 'Singapura \u00b7 Syarikat induk pengedaran',
            children: [
              { role: 'Singapura \u00b7 Pengedaran marin; pengedaran IQAir' },
              {
                role: 'Malaysia \u00b7 Pengedaran dan servis enjin sangkut',
                children: [{ role: 'Malaysia \u00b7 Pegangan hartanah' }],
              },
              { role: 'Indonesia \u00b7 Instrumen makmal dan pengedaran IQAir' },
            ],
          },
          { role: 'Singapura \u00b7 Makmal, penentukuran, pengesahan dan pengesanan gas' },
          { role: 'Singapura \u00b7 Pegangan pelaburan' },
        ],
      },
    ],
  },

  BUSINESSES: {
    sub:
      'Setiap satu daripada tiga teras kami beroperasi dengan kepakaran tersendiri, namun saling menyuap dalam satu ekosistem yang kukuh. Bersama-sama, ketiganya menghasilkan data, kepintaran dan keupayaan yang menjadi kelebihan daya saing kami.',
    pillar1: {
      eyebrow: 'Teras 1',
      h2: 'Enjin Hasil',
      intro:
        `Supratechnic dan SII bersama-sama membentuk tulang belakang penjana tunai Kumpulan — satu platform pengedaran merentas beberapa negara dan sektor yang dibina selama lebih ${HERITAGE_YEARS} tahun.`,
    },
    supratechnic: {
      tagline: 'Pengedaran marin · industri · penjagaan kesihatan',
      copy:
        'Supratechnic mengedarkan enjin marin, peralatan industri serta penyelesaian penjagaan kesihatan dan kualiti udara bermutu tinggi di Singapura, Malaysia dan Indonesia. Perkongsian lama dengan jenama terkemuka menyokong reputasi yang dibina atas kredibiliti teknikal dan standard perkhidmatan yang tinggi. Perniagaan ini sedang berkembang ke perdagangan elektronik — bermula dengan SupraYi — untuk sampai kepada pelanggan secara langsung.',
      facts: ['Diperbadankan 1968', 'Singapura · Malaysia · Indonesia', 'Ranking #249, Singapore SME 500 (2009)', 'Pengedar eksklusif Afli — SG · MY · ID'],
      afli: {
        label: 'Oktober 2026',
        h4: 'Afli — ramalan menangkap ikan berkuasa AI untuk nelayan kecil',
        copy:
          'Supratechnic telah menandatangani Perjanjian Kerjasama dengan syarikat teknologi perikanan Iceland, GreenFish hf., dan menjadi pengedar eksklusif Afli di Malaysia, Singapura dan Indonesia; SuprAI Capital menerajui hala tuju Kumpulan bagi Afli bersama GreenFish. Afli menggabungkan AI, cerapan satelit dan data oseanografi untuk menonjolkan kawasan yang lebih berkemungkinan terdapat ikan, dikemas kini sekurang-kurangnya setiap enam jam, dan berfungsi di luar talian ketika di laut. Ciri keselamatan pelayaran yang dirancang termasuk amaran lewat pulang kepada hubungan di darat dan fungsi kecemasan, dan setiap nelayan mengawal sama ada kedudukannya dikongsi. Perintis percuma untuk 50 nelayan dari sekurang-kurangnya tiga cawangan di kedua-dua pantai Semenanjung Malaysia akan berjalan empat hingga enam bulan sepanjang monsun, sebelum pelancaran komersial di tujuh cawangan di Malaysia.',
        note:
          'Afli tiada sambungan satelit dan bukan pengganti peralatan keselamatan yang diwajibkan undang-undang.',
        linkLabel: 'Majlis menandatangani, dalam gambar →',
        demo: {
          label: 'Tonton aplikasi ini digunakan →',
          note: 'Demonstrasi GreenFish · 9 min 29 s · sari kata BM',
          alt:
            'Cebisan daripada demonstrasi Afli: aplikasi memaparkan keadaan angin, ombak dan suhu di perairan Semenanjung Malaysia dan Sumatera.',
        },
      },
      heritage:
        'Pada tahun 1968, Supratechnic Pte Ltd diperbadankan di Singapura. Pada tahun 2009, Supratechnic disenaraikan pada kedudukan ke-249 dalam senarai Singapore Small and Medium Enterprises (SME) 500.',
      aftersales: {
        eyebrow: 'Jualan · Servis · Alat ganti',
        h4: 'Selepas jualan, bukan sekadar pembekalan',
        copy:
          'Perniagaan pengedaran dinilai pada apa yang berlaku selepas invois dikeluarkan. Supratechnic menjual, menyervis dan menyimpan alat ganti bagi jenama yang diwakilinya — dari bengkelnya dan pasukan servis bergerak yang datang ke bot.',
        items: [
          {
            title: 'Jualan',
            copy: 'Enjin dan peralatan marin daripada rakan jenama kami, di Singapura, Malaysia dan Indonesia.',
          },
          {
            title: 'Servis',
            copy: 'Teknisyen terlatih, di bengkel atau di jeti, memastikan enjin terus beroperasi sepanjang hayat perkhidmatannya.',
          },
          {
            title: 'Alat ganti',
            copy: 'Alat ganti tulen bagi enjin dan peralatan yang kami bekalkan, supaya pembaikan tidak bertukar menjadi pembinaan semula.',
          },
        ],
        caption: 'Menggerakkan kecemerlangan marin sejak 1968 — bengkel dan pasukan servis bergerak.',
      },
      outboards: {
        h4: 'Enjin sangkut',
        intro:
          'Supratechnic membawa rangkaian enjin sangkut HIDEA di seluruh rantau ini, dan pada Ogos 2026 Supratechnic (M) Sdn. Bhd. dilantik sebagai pengedar sah enjin sangkut Tohatsu bagi Semenanjung Malaysia.',
        footnote:
          'Penamaan siri dan model adalah milik pengeluar masing-masing. Fotografi produk bagi kedua-dua rangkaian masih menunggu kebenaran pemilik jenama, jadi kami tidak memaparkan apa-apa yang tidak boleh kami lesenkan.',
      },
      warranty: {
        eyebrow: 'Mengangkat teknologi',
        h4: 'Sistem waranti dalam talian sepenuhnya digital yang pertama di Asia untuk enjin sangkut marin',
        copy:
          'Satu platform yang menggabungkan pengedar, pembekal dan pelanggan dengan lancar. Pelanggan memindai kod QR untuk mendaftarkan produk; cawangan melengkapkan pemeriksaan pra-penghantaran secara digital; ibu pejabat mengesahkannya; dan pembekal meluluskan kes itu dalam sistem yang sama. Tuntutan berjalan dengan cara yang sama, daripada kerosakan dilaporkan sehingga pembaikan ditutup.',
        builtBy:
          'Dibina oleh SuprAI dan Frac atas Microsoft Power Platform, dan ditulis untuk kegunaan di lapangan dalam bahasa Inggeris, Bahasa Melayu dan Mandarin serentak. Platform ini tidak terikat kepada produk atau pembekal tertentu: ia boleh membawa apa-apa produk marin dan apa-apa pembekal yang diwakili Kumpulan. Paparan di bawah adalah daripada penggunaan pertama kami, bersama HIDEA.',
        roles: [
          { label: 'Pelanggan', copy: 'Memindai kod QR pada produk untuk mendaftarkannya dan melaporkan kerosakan.' },
          { label: 'Cawangan', copy: 'Melengkapkan pemeriksaan pra-penghantaran digital dan membuka tuntutan.' },
          { label: 'Ibu pejabat', copy: 'Mengesahkan rekod dan menyediakan pakej semakan untuk pembekal.' },
          {
            label: 'Pembekal',
            copy:
              'Meluluskan, menolak, meminta maklumat lanjut atau menangguh menunggu alat ganti — dan hanya melihat barisan kesnya sendiri, tiada yang lain.',
          },
        ],
        facts: [
          'Satu platform, tiga pihak',
          'Apa-apa produk marin, apa-apa pembekal',
          'Pendaftaran kod QR',
          'PDI digital, tanpa kertas',
          'Akses mengikut peranan',
          'Inggeris · Bahasa Melayu · 中文',
        ],
        link: { label: 'Baca buku panduan operasi →' },
        note:
          'Paparan ini adalah daripada penggunaan pertama platform bersama HIDEA, dan diambil daripada buku panduan operasinya sendiri. Pengenalan kakitangan dan pelanggan telah dilindungi.',
      },
    },
    suprayi: {
      tagline: 'Udara bersih · IQAir · Terus kepada pelanggan',
      copy:
        'SupraYi ialah perniagaan udara bersih terus-kepada-pelanggan Kumpulan, dikendalikan oleh Supratechnic (S) Pte Ltd sebagai pengedar sah IQAir di Singapura — jenama kualiti udara Switzerland yang dipercayai hospital dan kerajaan di tempat yang menuntut udara bersih tanpa kompromi. Ia juga menjadi medan ujian Kumpulan bagi keupayaan perdagangan elektronik, teknologi pemasaran dan data pelanggan.',
    },
    sii: {
      tagline: 'Makmal · Penentukuran · Pengesanan gas',
      copy:
        'SII menyampaikan penyelesaian instrumentasi, penentukuran dan pengesanan gas berpresisi kepada industri berkanun. Makmal dan perkhidmatan penentukurannya yang diakreditasi menyokong kredibiliti Kumpulan dengan pelanggan korporat dan institusi — serta menjadi laluan semula jadi ke arah analitis dipacu AI pada masa depan.',
      facts: [
        'Ditubuhkan 1975',
        'Makmal penentukuran dalaman SIICAL',
        'Singapura · Malaysia · Indonesia · Hong Kong · New Zealand',
        'Lebih 1,000 instrumen ditentukur setiap tahun',
        'Pengedar sah IGD — Singapura',
        'Usaha sama Kimera Health — SG · MY · ID',
      ],
      igd: {
        label: 'September 2026',
        copy:
          'International Gas Detectors — pengeluar pengesanan gas tetap dari United Kingdom dalam Safe Monitoring Group yang berpangkalan di Sweden — telah melantik SII sebagai pengedar sah dan rakan salurannya di Singapura. Perjanjian Pengedar dan Rakan Saluran ditandatangani pada 29 September 2026 untuk tempoh awal tiga puluh enam bulan dan merangkumi promosi, penjualan, sokongan reka bentuk sistem, pemasangan, pentauliahan, penyervisan dan penentukuran produk pengesanan gas IGD di seluruh Singapura. Ia menggabungkan teknologi pengesanan kejuruteraan UK IGD dengan SIICAL, makmal penentukuran kami yang diakreditasi, supaya pelanggan memperoleh sistem, pentauliahan dan penentukuran dari satu tempat.',
        linkLabel: 'Siaran akhbar bersama →',
      },
      jv: {
        label: 'Ogos 2026',
        copy:
          'SII telah memeterai perjanjian usaha sama dan kerjasama komersial dengan tiga syarikat Kimera Health, ditandatangani di CPHI Korea 2026 di Seoul, merangkumi Singapura, Malaysia dan Indonesia. Perjanjian ini menggabungkan instrumentasi, penentukuran, pengesahan dan pemantauan persekitaran SII — serta sistem udara bersih IQAir Kumpulan — dengan lesen peranti perubatan Kimera Health dan aksesnya kepada hospital, pusat pembedahan dan klinik pakar. Usaha sama ini tidak diperbadankan: tiada syarikat baharu, tiada sumbangan modal dan tiada balasan. Surat hasrat yang berasingan, yang tidak mengikat, merekodkan hasrat untuk merundingkan pemerolehan SII sehingga 51% dalam satu atau lebih syarikat tersebut.',
        linkLabel: 'Pengumuman SGXNet →',
      },
      supportingLine:
        'Soalan paling penting bagi seorang pengurus pengesahan ialah siapa yang menentukur alat penentukur itu. Dalam kes kami, kami sendiri.',
    },
    siiPartners: [
      { line: 'Pengesahan terma berwayar dan tanpa wayar.', detail: 'E-Val Pro, TrackSense Pro Mini/Micro, tatasusunan penderia.' },
      {
        line: 'Pengesanan gas industri kejuruteraan UK.',
        detail: 'Pellistor MK8, rangkaian VOC, panel kawalan boleh alamat.',
      },
      {
        line: 'Keselamatan CO₂ untuk minuman, hospitaliti dan penjagaan kesihatan.',
        detail: 'Mk9, Mk10, Scout Glow, SMB Safety Valve.',
      },
      { line: 'Teknologi penderia gas inframerah.', detail: 'Modul penderia IR berkestabilan tinggi.' },
    ],
    pillar2: {
      eyebrow: 'Teras 2',
      h2: 'Sistem Saraf Pusat',
      intro:
        'SuprAI Pte Ltd membina produk AI, automasi dan teknologi pemasaran Kumpulan — serta mengendalikan perkhidmatan bersama yang mengikat Kumpulan.',
      blocks: [
        {
          title: 'Buktikan',
          copy:
            'Perniagaan kami sendiri ialah pelanggan pertama SuprAI. Setiap alat digunakan pada operasi sebenar, dan kepintaran daripada perniagaan itu kembali menguatkan produk.',
        },
        {
          title: 'Produkkan',
          copy:
            'Apabila sesuatu alat terbukti memacu trafik, kunjungan dan hasil bagi perniagaan kami sendiri, bukti tarikan itu — pelanggan sebenar, angka sebenar — menjadikannya produk yang boleh dipercayai dan boleh dijual.',
        },
        {
          title: 'Kembangkan',
          copy:
            'Kami menjual daripada kekuatan teras kami dahulu — Singapura dan Malaysia — kemudian Indonesia dan rantau yang lebih luas, seterusnya ke luar. Daripada pusat kos Kumpulan hari ini kepada pusat keuntungan esok.',
        },
        {
          title: 'Perkhidmatan Kumpulan',
          copy:
            'SuprAI Pte Ltd juga memusatkan kewangan, sumber manusia, IT, perundangan dan tadbir urus komersial seluruh Kumpulan — mengurangkan pertindihan kos dan menetapkan satu standard operasi di tiga negara.',
        },
      ],
      builtAndRunning: 'Dibina dan sedang berjalan',
    },
    pillar3: {
      eyebrow: 'Teras 3',
      h2: 'Pemecut Keupayaan',
      intro:
        'Melalui cadangan kepentingan minoriti strategik dalam sebuah syarikat permulaan teknologi, Kumpulan memperoleh permulaan awal dalam teknologi dan disiplin yang dituntut oleh cita-cita AI kami.',
      blocks: [
        {
          title: 'Pemecut',
          copy:
            'Syarikat permulaan itu membawa keupayaan pengurusan projek, pembangunan produk dan teknologi teras yang belum dimiliki Kumpulan secara dalaman — membolehkan kami mula membina serta-merta dan bukan dari kosong.',
        },
        {
          title: 'Pilihan',
          copy:
            'Pengesahannya di bawah rangka kerja pengendali pasaran diiktiraf Suruhanjaya Sekuriti Malaysia memberikan Kumpulan pintu masuk yang disahkan pengawal selia ke dalam tokenisasi aset dunia nyata — untuk diterokai secara berperingkat apabila pasaran itu matang.',
        },
        {
          title: 'Urutan',
          copy:
            'AI, automasi dan teknologi pemasaran didahulukan — keperluan segera setiap PKS. Tokenisasi aset dunia nyata berjalan selari dan berkembang kemudian.',
        },
      ],
      disclaimer:
        'Pelaburan dalam syarikat permulaan teknologi itu masih merupakan cadangan dan tertakluk kepada kelulusan yang diperlukan. Tiada apa-apa di halaman ini merupakan tawaran atau pelawaan.',
    },
  },

  GOVERNANCE: {
    sub:
      'Tadbir urus yang mantap ialah asas kepercayaan yang sedang kami bina semula dengan pihak berkepentingan. Kumpulan komited kepada prinsip Kod Tadbir Urus Korporat Singapura serta kepimpinan yang telus dan bertanggungjawab.',
    board: {
      h2: 'Lembaga Pengarah',
      intro:
        'Lembaga kami menghimpunkan pengalaman merentas pasaran modal, industri, kewangan dan tadbir urus.',
      pending:
        'Profil pengarah akan diterbitkan setelah mendapat kelulusan Lembaga Pengarah dan Setiausaha Syarikat.',
    },
    exco: {
      h2: 'Jawatankuasa Eksekutif',
      intro:
        'Jawatankuasa Eksekutif Kumpulan mengetuai pengurusan harian di tiga negara dan tiga teras kami.',
      pending:
        'Profil pengarah akan diterbitkan setelah mendapat kelulusan Lembaga Pengarah dan Setiausaha Syarikat.',
    },
    committees: {
      h2: 'Jawatankuasa Lembaga',
      intro:
        'Lembaga disokong oleh empat jawatankuasa, setiap satu dengan komposisi dan bidang tugasnya sendiri.',
      items: [
        { note: 'Disusun semula pada 30 Julai 2026.' },
        { note: 'Disusun semula pada 30 Julai 2026.' },
        { note: 'Disusun semula pada 30 Julai 2026.' },
        { note: 'Ditubuhkan pada 30 Julai 2026. Terma Rujukan diterima pakai pada 16 Oktober 2026.' },
      ],
      source: 'Menurut Laporan Tahunan 2026 Syarikat (28 Oktober 2026).',
    },
    policies: {
      h2: 'Tadbir urus korporat & polisi',
      intro: 'Rangka kerja tadbir urus dan polisi utama kami tersedia di bawah.',
      items: [
        {
          title: 'Laporan Tadbir Urus Korporat',
          caption: 'Laporan Tahunan 2026 · halaman 15–79',
          linkLabel: 'Baca dalam Laporan Tahunan →',
        },
        {
          title: 'Kod Tatakelakuan dan Etika Perniagaan (Lembaga Pengarah)',
          caption: 'Diterima pakai 16 Oktober 2026 · dokumen akan menyusul',
        },
        {
          title: 'Polisi Pemberi Maklumat',
          caption: 'Diterima pakai 16 Oktober 2026 · dokumen akan menyusul',
          note:
            'Pekerja Kumpulan dan pihak luar boleh membangkitkan kebimbangan kepada Pengerusi Jawatankuasa Audit dan Pengurusan Risiko. Identiti pemberi maklumat sentiasa dirahsiakan.',
        },
        {
          title: 'Polisi Dividen',
          statement:
            'Syarikat pada masa ini tidak mempunyai polisi dividen yang rasmi. Syarikat berhasrat untuk menetapkan dan mendedahkan polisi tersebut dalam Laporan Tahunan FY2027. Lembaga Pengarah tidak mengesyorkan dividen bagi FY2026.',
        },
        {
          title: 'Polisi Perhubungan Pelabur',
          statement:
            'Syarikat berhasrat untuk menerima pakai polisi perhubungan pelabur yang rasmi dalam FY2027, sebelum Kaedah 710B Manual Penyenaraian berkuat kuasa pada 1 Januari 2027.',
        },
      ],
      source: 'Menurut Laporan Tahunan 2026 Syarikat (28 Oktober 2026).',
    },
  },

  SUSTAINABILITY: {
    intro:
      'Sebagai kumpulan yang tersenarai di SGX, kami mengakui tanggungjawab untuk beroperasi secara mampan dan melaporkan prestasi alam sekitar, sosial dan tadbir urus kami dengan telus.',
    reporting: {
      h2: 'Pelaporan kemampanan',
      paragraphs: [
        'SGX RegCo telah memberikan Syarikat pengecualian daripada keperluan pelaporan kemampanan bagi FY2022 hingga FY2026. Syarikat mengumumkan butiran pengecualian itu pada 7 Oktober 2026.',
        'Sepanjang tempoh ini Syarikat berada di bawah pengurusan kehakiman yang berpanjangan, perdagangan sahamnya digantung sejak 23 Februari 2024, dan operasi Kumpulan terjejas dengan ketara.',
        'Setelah proses penyelarasan semula selesai, Syarikat berhasrat untuk mematuhi keperluan pelaporan kemampanan yang berkenaan di bawah Manual Penyenaraian SGX-ST mulai FY2027.',
      ],
    },
    foundations: {
      h2: 'Asas tadbir urus',
      items: [
        'Lembaga Pengarah disusun semula pada Julai 2026 dengan majoriti pengarah bebas.',
        'Jawatankuasa Audit dan Pengurusan Risiko, Jawatankuasa Pencalonan dan Jawatankuasa Imbuhan masing-masing dipengerusikan oleh pengarah bebas.',
        'Jawatankuasa AI dan Teknologi menyelia penggunaan teknologi dan data oleh Kumpulan, serta risiko keselamatan siber, perlindungan data dan tadbir urus yang berkaitan.',
        'Kod Tatakelakuan dan Etika Perniagaan bagi ahli Lembaga Pengarah, dan Polisi Pemberi Maklumat yang dikemas kini, diterima pakai pada 16 Oktober 2026.',
        'Juruaudit bebas mengeluarkan pendapat tanpa pengubahsuaian ke atas penyata kewangan FY2026.',
      ],
    },
    people: {
      h2: 'Warga kerja kami',
      text:
        'Buku Panduan Pekerja yang baharu dan rangka kerja merit-demerit telah diperkenalkan di seluruh operasi Kumpulan di Malaysia, Singapura dan Indonesia.',
    },
    archive: {
      h2: 'Arkib pelaporan',
      text:
        'Laporan kemampanan pertama Syarikat di bawah Manual Penyenaraian SGX-ST dijangka bagi FY2027.',
    },
    source: 'Menurut Laporan Tahunan 2026 Syarikat (28 Oktober 2026).',
  },

  VERIFIED: {
    eyebrow: 'Perhubungan Pelabur',
    h1: 'Dokumen disahkan',
    intro:
      'Dokumen pendedahan utama kami, setiap satunya dimeterai pada rangkaian blok awam supaya sesiapa sahaja boleh mengesahkan bahawa salinan yang dipegang mereka adalah tepat sama dengan yang kami terbitkan.',
    notice:
      'SGXNet ialah rekod berwibawa bagi pengumuman Syarikat. Halaman ini ialah semakan tambahan: ia membuktikan fail di bawah ialah fail yang diterbitkan di laman web ini pada tarikh yang ditunjukkan, dan bahawa ia tidak diubah sejak itu.',
    steps: [
      {
        title: 'Diterbitkan di SGXNet',
        text: 'Setiap dokumen mula-mula dikeluarkan kepada pasaran melalui SGXNet.',
      },
      {
        title: 'Dimeterai pada rangkaian blok',
        text:
          'Kami merekodkan cap jari digital setiap fail pada rangkaian blok awam \u2014 satu rekod dengan tarikh yang tidak boleh diubah oleh sesiapa pun, termasuk Syarikat.',
      },
      {
        title: 'Semak sendiri mana-mana salinan',
        text:
          'Muatkan fail PDF di bawah; peranti anda akan mengira cap jarinya dan memberitahu anda sama ada ia sepadan.',
      },
    ],
    documents: {
      h2: 'Dokumen yang dimeterai',
      releasedLabel: 'Dikeluarkan di SGXNet',
      viewLabel: 'Lihat dokumen',
      technicalLabel: 'Butiran teknikal',
      fingerprintLabel: 'Cap jari SHA-256',
      sizeLabel: 'Saiz fail',
      proofLabel: 'Muat turun bukti rangkaian blok (.ots)',
      verifyLabel: 'Sahkan di OpenTimestamps',
      independent:
        'Untuk mengesahkan secara bebas, muat turun dokumen dan fail buktinya, buka opentimestamps.org dan lepaskan kedua-dua fail ke halaman tersebut.',
      bases:
        'Laporan Tahunan menyatakan bahawa asas bagi penafian pendapat itu berkaitan sebahagian besarnya dengan rekod, pengesahan dan peristiwa sebelum dan semasa pengurusan kehakiman (Laporan Tahunan 2026, halaman 3).',
      pending:
        'Dimeterai pada {sealed}. Pengesahan rangkaian blok sedang berjalan (biasanya beberapa jam).',
      confirmed:
        'Dimeterai pada {date}. Disahkan pada rangkaian blok awam pada {blockDate} (blok {height}).',
      confirmedNoTime: 'Dimeterai pada {date}. Disahkan pada rangkaian blok awam (blok {height}).',
      empty: 'Dokumen yang dimeterai akan dipaparkan di sini sebaik sahaja bukti pertama direkodkan.',
      bySlug: {
        'annual-report-2026': {
          title: 'Laporan Tahunan 2026 (FY2022\u2013FY2026)',
          opinion:
            'Mengandungi penyata kewangan teraudit FY2026; juruaudit mengeluarkan pendapat tanpa pengubahsuaian bagi FY2026.',
        },
        'fs-fy2025': {
          title: 'Penyata kewangan teraudit, tahun kewangan berakhir 31 Mac 2025',
          opinion:
            'PKF-CAP LLP: penafian pendapat ke atas prestasi kewangan disatukan dan aliran tunai Kumpulan; pendapat tanpa pengubahsuaian ke atas kedudukan kewangan Kumpulan dan Syarikat.',
        },
        'fs-fy2024': {
          title: 'Penyata kewangan teraudit, tahun kewangan berakhir 31 Mac 2024',
          opinion: 'PKF-CAP LLP: penafian pendapat.',
        },
        'fs-fy2023': {
          title: 'Penyata kewangan teraudit, tahun kewangan berakhir 31 Mac 2023',
          opinion: 'PKF-CAP LLP: penafian pendapat.',
        },
        'fs-fy2022': {
          title: 'Penyata kewangan teraudit, tahun kewangan berakhir 31 Mac 2022',
          opinion: 'PKF-CAP LLP: penafian pendapat.',
        },
      },
    },
    checker: {
      h2: 'Semak salinan yang dihantar kepada anda',
      label: 'Pilih fail PDF',
      hint:
        'Tiada apa-apa dimuat naik. Pelayar anda membaca fail itu dan mengira cap jarinya pada peranti anda sendiri.',
      working: 'Mengira cap jari\u2026',
      yourFingerprint: 'Cap jari fail anda',
      match: 'Fail ini adalah sama dengan {title} seperti yang diterbitkan pada {date}.',
      noMatch:
        'Fail ini tidak sepadan dengan mana-mana dokumen di halaman ini. Ia mungkin telah diubah, atau ia mungkin versi yang berbeza. Sila semak SGXNet untuk salinan yang berwibawa.',
      error: 'Fail itu tidak dapat dibaca. Sila pilih fail PDF.',
    },
    faq: {
      h2: 'Soalan',
      items: [
        {
          q: 'Apakah itu rangkaian blok?',
          a:
            'Satu rekod awam yang disimpan oleh beribu-ribu komputer di seluruh dunia. Setelah sesuatu ditulis ke dalamnya, ia tidak boleh diubah atau ditarikhkan semula.',
        },
        {
          q: 'Apakah yang dibuktikan oleh meterai ini?',
          a:
            'Bahawa fail-fail ini diterbitkan di laman web ini selewat-lewatnya pada tarikh yang ditunjukkan, dan ia tidak berubah sejak itu. Ia tidak membuktikan apa-apa tentang kandungannya; pendapat audit dinyatakan pada setiap kad.',
        },
        {
          q: 'Adakah ini menggantikan SGXNet?',
          a: 'Tidak. SGXNet kekal sebagai sumber berwibawa bagi semua pengumuman Syarikat.',
        },
        {
          q: 'Mengapa memeterai dokumen yang sudah ada di SGXNet?',
          a:
            'Dokumen sering dimajukan sebagai lampiran. Semakan ini membolehkan sesiapa sahaja mengesahkan bahawa salinan yang dimajukan itu tidak diubah, tanpa perlu mempercayai penghantarnya.',
        },
      ],
    },
  },

  NEWSROOM: {
    eyebrow: 'Ruang Berita',
    h1: 'Ruang Berita',
    sub: 'Berita, liputan media dan perkembangan terkini dari seluruh Kumpulan.',
    press: {
      h2: 'Siaran akhbar',
      intro:
        'Berita dan perkembangan korporat terkini kami, dikeluarkan selaras dengan kewajipan pendedahan berkanun kami.',
      categoryLabel: 'Kategori',
      categories: [
        { label: 'Semua' },
        { label: 'Korporat' },
        { label: 'Perniagaan' },
        { label: 'Teknologi' },
      ],
      fromLabel: 'Dari',
      toLabel: 'Hingga',
      searchLabel: 'Cari',
      searchPlaceholder: 'Cari siaran akhbar',
      readLabel: 'Baca →',
      readAria: 'Baca siaran',
      emptyLabel: 'Belum ada siaran akhbar',
      emptyCopy:
        'Siaran akhbar akan muncul di sini sebaik sahaja ia dikeluarkan. Siaran diterbitkan selaras dengan kewajipan pendedahan berkanun Kumpulan.',
      englishNote:
        'Tajuk dan ringkasan siaran akhbar kekal dalam bahasa Inggeris: itulah teks yang dikeluarkan melalui SGXNet.',
    },
    coverage: {
      h2: 'Liputan media',
      intro: 'Liputan terpilih mengenai Kumpulan dalam media.',
      emptyLabel: 'Belum ada liputan disenaraikan',
      emptyCopy: 'Liputan media terpilih akan disenaraikan di sini apabila ia diterbitkan.',
      englishNote: 'Tajuk berita dipaparkan dalam bahasa asal penerbitannya.',
    },
    filings: {
      h2: 'Pemfailan SGXNet terkini',
      intro:
        'Tiga pengumuman terbaharu yang dikeluarkan Syarikat melalui SGXNet. Ini ialah rekod rasmi: tajuk dan dokumen dikekalkan tepat seperti yang difailkan.',
      viewAll: { label: 'Lihat semua pengumuman →' },
      empty:
        'Pengumuman akan muncul di sini sebaik sahaja Kumpulan menyambung pemfailan di SGXNet.',
    },
    gallery: {
      h2: 'Galeri media',
      intro:
        'Fotografi Kumpulan ketika bekerja — warga kami, makmal kami dan pemasangan kami. Setiap imej merekodkan tempat ia diterbitkan dan apa yang ditunjukkannya. Tersedia untuk kegunaan editorial atas permintaan.',
      featureEyebrow: 'Sejak 1975',
      sourceLabel: 'Sumber',
      requestLabel: 'Minta fail asal →',
    },
    leadership: {
      h2: 'Ketua Pegawai Eksekutif di pasaran',
      intro:
        'Melvin Tan Wei Yang, Ketua Pegawai Eksekutif, menulis mengenai kemajuan komersial Kumpulan dan keadaan pasaran modal Singapura. Setiap catatan dipautkan sepenuhnya.',
      linkLabel: 'Baca catatan di LinkedIn →',
      noImageLabel: 'Catatan teks',
      quoteNote: 'Petikan dikekalkan dalam bahasa asal penerbitannya.',
    },
    enquiries: {
      h2: 'Pertanyaan media',
      intro: 'Untuk pertanyaan media, sila hubungi pasukan komunikasi kami.',
      contactLabel: 'Hubungan komunikasi',
      linkLabel: 'Hubungi pasukan komunikasi →',
    },
    assets: {
      h2: 'Imej & aset jenama',
      intro: 'Logo dan imej yang diluluskan untuk kegunaan media tersedia atas permintaan.',
      link: { label: 'Minta aset →' },
    },
  },

  MEDIA_GALLERY: [
    {
      title: 'Afli — kerjasama GreenFish, dimeterai di Kuala Lumpur',
      alt:
        'Dua penandatangan duduk di meja menandatangani perjanjian dengan lima rakan sekerja berdiri di belakang, di hadapan latar bertulis “Supratechnic × GreenFish — Collaboration Agreement Signing Ceremony”.',
      context:
        'Supratechnic menandatangani Perjanjian Kerjasama dengan syarikat teknologi perikanan Iceland, GreenFish hf., pada 14 Oktober 2026 dan menjadi pengedar eksklusif Afli — aplikasi menangkap ikan berkuasa AI untuk nelayan kecil — di Malaysia, Singapura dan Indonesia. Perintis percuma untuk 50 nelayan berjalan sepanjang monsun sebelum pelancaran komersial di tujuh cawangan di Malaysia. Empat belas gambar majlis itu, berserta demonstrasi aplikasi oleh GreenFish, diterbitkan bersama siaran akhbar.',
      caption: 'Mercure Kuala Lumpur Trion, 14 Oktober 2026.',
      sourceLabel: 'Siaran akhbar, dengan galeri penuh',
    },
    {
      title: 'IGD melantik SII sebagai pengedar sahnya di Singapura',
      alt:
        'Mr Melvin Tan Wei Yang dan Mr Uu Su Haw duduk di meja bilik lembaga menandatangani Perjanjian Pengedar dan Rakan Saluran, dengan empat pengarah dan pegawai USP Group berdiri di belakang mereka.',
      context:
        'International Gas Detectors telah melantik SII sebagai pengedar sah dan rakan salurannya di Singapura, dimeterai melalui Perjanjian Pengedar dan Rakan Saluran yang ditandatangani pada 29 September 2026 untuk tempoh awal tiga puluh enam bulan. Ia merangkumi promosi, penjualan, pemasangan, penyervisan dan sokongan penentukuran sistem pengesanan gas tetap IGD yang direka di United Kingdom di seluruh Singapura, dan menggabungkannya dengan makmal penentukuran SIICAL serta perkhidmatan pengesahan SII.',
      caption:
        'Dari kiri: Mr Toh Hai Joo, Pengarah Bebas Bukan Eksekutif, USP Group Limited; Mr Chan Chung Khang, Pengerusi Bebas Bukan Eksekutif, USP Group Limited; Mr Melvin Tan Wei Yang, Ketua Pegawai Eksekutif, Scientific & Industrial Instrumentation Pte. Ltd. dan Pengarah Eksekutif & CEO, USP Group Limited; Mr Uu Su Haw, Presiden, Asia Pasifik, Safe Monitoring Group; Mr Leow Yong Kin, Ketua Pegawai Kewangan, USP Group Limited; dan Ms Maio Dangi, Timbalan Pengerusi Bukan Bebas Bukan Eksekutif, USP Group Limited, pada majlis menandatangani Perjanjian Pengedar dan Rakan Saluran pada 29 September 2026.',
      sourceLabel: 'Siaran akhbar bersama',
    },
    {
      title: 'Perjanjian yang ditandatangani, ditukar',
      alt:
        'Mr Melvin Tan Wei Yang dan Mr Uu Su Haw bertukar fail Perjanjian Pengedar dan Rakan Saluran yang telah ditandatangani, disaksikan oleh pengarah dan pegawai USP Group.',
      context:
        'IGD ialah pengeluar pengesanan gas tetap dari United Kingdom dalam Safe Monitoring Group yang berpangkalan di Sweden, dengan lebih 100 tahun kejuruteraan pengesanan gas. Pelantikan ini menandakan langkah seterusnya dalam strategi pertumbuhan Asia Pasifik kumpulan itu selepas kemasukannya ke rantau ini pada awal 2026, dan memberi pelanggan di Singapura satu laluan daripada reka bentuk dan pemasangan sistem sehingga penentukuran, penyervisan dan sokongan sepanjang hayat.',
      caption:
        'Mr Melvin Tan Wei Yang, CEO SII, dan Mr Uu Su Haw, Presiden, Asia Pasifik, Safe Monitoring Group, bertukar perjanjian yang telah ditandatangani.',
      sourceLabel: 'Siaran akhbar bersama',
    },
    {
      title: 'Lima puluh tahun Scientific & Industrial Instrumentation',
      alt:
        'Kakitangan, keluarga dan para tetamu Scientific & Industrial Instrumentation berkumpul di bawah candelier di York Hotel, Singapura, di hadapan skrin bertulis “Celebrating 50 years of Science”.',
      context:
        'Scientific & Industrial Instrumentation Pte. Ltd. (SII) ditubuhkan di Singapura pada tahun 1975 — dekad ketika negara ini mula menetapkan haluannya untuk menjadi hab pembuatan dan sains hayat Asia Tenggara. Sejak awal, tujuan kami ialah memberikan industri paling menuntut di rantau ini keupayaan pengukuran, penentukuran dan keselamatan gas yang mereka perlukan untuk beroperasi pada standard antarabangsa.',
      caption: 'Sambutan ulang tahun ke-50 SII, Singapura.',
    },
    {
      title: 'Usaha sama Kimera Health, ditandatangani di Seoul',
      alt:
        'Delegasi SII dan Kimera Health bergambar bersama di lobi sebuah hotel di Seoul pada hari perjanjian usaha sama dan kerjasama komersial ditandatangani.',
      context:
        'SII dan tiga syarikat Kimera Health menandatangani perjanjian usaha sama dan kerjasama komersial di CPHI Korea 2026 di Seoul pada 26 Ogos 2026. Perjanjian ini merangkumi pemasaran bersama, pengedaran, pendaftaran dan penyervisan di Singapura, Malaysia dan Indonesia — termasuk rangkaian udara bersih IQAir Kumpulan di Singapura dan Indonesia. Ia tidak diperbadankan: tiada syarikat baharu, tiada sumbangan modal dan tiada balasan.',
      caption: 'Kedua-dua delegasi di Seoul, 26 Ogos 2026.',
      sourceLabel: 'Pengumuman SGXNet',
    },
    {
      title: 'Bengkel dan pusat servis Supratechnic',
      alt:
        'Tiga jurutera servis Supratechnic berpakaian seragam berjenama berdiri di sisi van servis Supratechnic di luar bengkel dan pusat servis.',
      context:
        'Jualan ialah bahagian hadapan perniagaan marin; servis pula yang mengekalkannya. Bengkel dan pusat servis menyimpan alat ganti serta jurutera yang memasangnya, supaya pelanggan yang membeli enjin sangkut mempunyai tempat untuk membawanya kembali.',
      caption: 'Jurutera servis dan unit servis bergerak.',
    },
    {
      title: 'Penentukuran sedang dijalankan',
      alt:
        'Seorang jurutera SII berkot makmal putih menyambungkan tiub ke sebuah alat penentukuran di atas meja makmal.',
      context:
        'SIICAL ialah makmal dalaman, bukan pengaturan yang disumber luar. Instrumen ditentukur oleh jurutera SII terhadap standard rujukan yang dimiliki dan dipelihara oleh Kumpulan sendiri — itulah yang menjadikan sertifikatnya boleh dipertahankan apabila juruaudit bertanya.',
      caption: 'Seorang jurutera menentukur instrumen pelanggan.',
    },
    {
      title: 'Pengesanan gas ditentukur di tempat ia dipasang',
      alt:
        'Seorang teknisyen SII berjaket keselamatan mengenakan gas ujian pada pengesan gas tetap yang dipasang pada dinding kilang.',
      context:
        'Pengesanan gas tetap perlu dibuktikan di tempatnya. Pasukan kami mengenakan gas ujian pada setiap kepala pengesan di lokasi, merekodkan tindak balasnya, dan mengesahkan pemasangan itu — merentas kemudahan farmaseutikal, semikonduktor serta minyak dan gas di rantau ini.',
      caption: 'Ujian bump pada kepala pengesan tetap di lokasi.',
    },
    {
      title: 'Pemantauan keselamatan CO₂',
      alt:
        'Seorang jurutera berkot makmal mengendalikan peralatan pemantauan karbon dioksida di sebuah kemudahan minuman.',
      context:
        'Apabila CO₂ terbocor, orang tercedera dengan cepat. SII ialah rakan serantau yang dilantik LogiCO₂ dan memasang, mentauliah, menentukur serta menyervis platform itu di kilang bir, ruang bawah tanah hotel, dapur, hospital dan sekolah.',
      caption: 'Pemantauan LogiCO₂ di lokasi minuman dan hospitaliti.',
    },
    {
      title: 'Sistem pengesahan terma',
      alt:
        'Paparan sistem pengesahan menunjukkan saluran penderia suhu semasa larian pemetaan terma.',
      context:
        'Sistem pengesahan Ellab dan Kaye — Validator 2000, E-Val Pro, TrackSense Pro — dibekalkan, ditauliah dan diservis untuk pengeluar farmaseutikal, bioteknologi, peranti perubatan dan makanan di seluruh rantau ini.',
      caption: 'Larian pemetaan terma sedang dijalankan.',
    },
    {
      title: 'Standard rujukan di SIICAL',
      alt: 'Kebuk suhu dan kelembapan Kambic KK-105 CH di makmal penentukuran SIICAL.',
      context:
        'Kebuk Kambic KK-105 CH, bersama SPRT, Fluke Super-Thermometer, Humor 20 dan penjana Thunder Scientific 2500, ialah aras rujukan yang menjadi asas penentukuran makmal ini.',
      caption: 'Kebuk suhu dan kelembapan Kambic KK-105 CH.',
    },
    {
      title: 'IQAir di rumah',
      alt: 'Penulen udara IQAir Atem X dipasang di ruang tamu kediaman.',
      context:
        'SupraYi ialah perniagaan udara bersih terus-kepada-pelanggan Kumpulan. Supratechnic memegang pelantikan pengedaran IQAir bagi Singapura, dan penurasan bermutu klinikal yang sama seperti yang dijual kepada hospital dijual kepada rumah tangga.',
      caption: 'IQAir Atem X di sebuah rumah di Singapura.',
    },
  ],

  LEADERSHIP_POSTS: [
    {
      title: 'Bercakap di Digital Investor Relations Masterclass',
      alt:
        'Grafik promosi Digital Investor Relations Masterclass bertulis “Is the market recognising your company’s full value?”, dengan SGX sebagai rakan strategik.',
    },
    {
      title: 'Suara pelabur dalam panel pelaporan STI30',
      alt:
        'Salinan penyelidikan pelaporan dan komunikasi STI30 oleh Black Sun Asia Pacific disusun di atas meja di Auditorium SGX.',
    },
    {
      title: 'Ahli panel “Unlocking Value Through Trust”',
      alt:
        'Grafik sorotan penceramah menampilkan Melvin Tan sebagai ahli panel bagi pelancaran penyelidikan STI30 Black Sun Global dan SIAS.',
    },
    {
      title: 'SupraYi dilancarkan sebagai saluran IQAir untuk Singapura',
      alt:
        'Halaman akhbar Lianhe Zaobao melaporkan hak pengedaran tunggal Supratechnic bagi IQAir di Singapura serta pelancaran platform e-dagang SupraYi.',
    },
    {
      title: 'Dari mahkamah ke bilik lembaga: reformasi kustodi dan Akta Syarikat',
      alt:
        'Melvin Tan duduk sendirian di dalam auditorium di hadapan skrin bertulis “Extraordinary General Meeting of USP Group Limited”.',
    },
    {
      title: 'Dilantik pengedar eksklusif Hidea Outboards',
      alt:
        'Melvin Tan Wei Yang, Ketua Pegawai Eksekutif Supratechnic (M) Sdn. Bhd., berjabat tangan dengan Zheng Huali, Pengasas dan Pengerusi Eksekutif Hidea Power Machinery Co., Ltd.',
    },
    {
      title: 'Ditampilkan oleh SIAS mengenai tadbir urus korporat dalam era AI',
    },
  ],

  CONTACT: {
    h1: 'Hubungi kami',
    intro:
      'Sama ada anda pelanggan, rakan kongsi, pelabur atau ahli media, kami berbesar hati mendengar daripada anda.',
    privacy:
      'Dengan menghantar, anda bersetuju dengan Polisi Privasi kami. Butiran anda digunakan hanya untuk menjawab pertanyaan anda.',
    success: 'Terima kasih — mesej anda telah diterima. Kami akan menghubungi anda tidak lama lagi.',
    error: 'Berlaku masalah. Sila periksa medan yang ditandakan dan cuba lagi.',
    officesHeading: 'Pejabat kami',
    registered: {
      label: 'Pejabat berdaftar',
      note: 'Berkuat kuasa 28 Julai 2026, menurut pengumuman SGXNet Syarikat.',
    },
    hours: 'Isnin–Jumaat, 8.30 pagi – 5.00 petang (waktu Singapura).',
    offices: [
      { name: 'Ibu Pejabat Kumpulan — Singapura' },
      {
        name: 'Supratechnic',
        note:
          'Jualan, servis dan alat ganti enjin sangkut marin — cawangan di seluruh Singapura dan Semenanjung Malaysia, dengan rangkaian pengedar.',
        branches: [{ label: 'Cawangan Singapura' }, { label: 'Pejabat serantau Malaysia' }],
      },
      { name: 'Supratechnic Indonesia' },
      { name: 'SII Asia' },
      { name: 'SupraYi Singapura' },
    ],
  },

  OUTBOARD_RANGES: [
    {
      note: 'Hangzhou Hidea Power Machinery. Diedarkan oleh Supratechnic di seluruh rantau ini.',
      ranges: [
        { name: 'Enjin sangkut empat lejang' },
        { name: 'Enjin sangkut tugas komersial' },
        { name: 'Enjin sangkut pam jet' },
        { name: 'Rangkaian EFI dan dua lejang', models: 'Siri suntikan bahan api elektronik dan dua lejang' },
      ],
    },
    {
      note:
        'Supratechnic (M) Sdn. Bhd. telah dilantik sebagai pengedar sah enjin sangkut Tohatsu oleh Tai Hua Agencies (K.L) Sdn. Bhd., pengedar rasmi Malaysia, bagi wilayah jualan yang meliputi Semenanjung Malaysia (pengumuman SGXNet, 18 Ogos 2026).',
      ranges: [
        { name: 'Empat lejang mudah alih (2.5–20 hp)' },
        { name: 'Empat lejang pertengahan (25–140 hp)' },
        { name: 'Enjin sangkut berkuasa tinggi (150–250 hp)' },
        { name: 'Dua lejang dan EverRun', models: 'Siri M · Siri MX EverRun · M25H JET' },
      ],
    },
  ],

  WARRANTY_SCREENS: [
    {
      title: 'Satu aplikasi, empat peranan',
      caption:
        'Skrin utama. Apa yang boleh dibuka oleh pengguna bergantung pada peranan yang digunakan semasa masuk — cawangan, ibu pejabat, pembekal atau pelanggan.',
    },
    {
      title: 'Pemeriksaan pra-penghantaran digital',
      caption:
        'Pemeriksaan pra-penghantaran dilengkapkan dalam aplikasi, soalan demi soalan, dengan catatan — tanpa kertas, dan tiada waranti diaktifkan tanpanya.',
    },
    {
      title: 'Pembekal membuat keputusan dalam sistem yang sama',
      caption:
        'Pembekal — HIDEA dalam penggunaan ini — hanya melihat barisan semakan akhirnya sendiri: rujukan kes, jenisnya, cawangan dan statusnya. Luluskan, tolak, minta maklumat lanjut, atau tangguh menunggu alat ganti.',
    },
  ],

  SII_LEADERSHIP: [
    { role: 'Ketua Pegawai Eksekutif' },
    { role: 'Ketua Pegawai Operasi' },
    { role: 'Pengarah Eksekutif & Ketua Pegawai Kewangan' },
    { role: 'Ketua Pembangunan Korporat' },
    { role: 'Pengurus Kewangan & Sumber Manusia' },
    { role: 'Pengurus Pembangunan Pasaran' },
    { role: 'Pengurus Makmal' },
    { role: 'Penolong Pengurus Perkhidmatan & Teknikal' },
    { role: 'Penolong Pengurus Perkhidmatan & Teknikal' },
  ],
};

export default ms;
